// frontend/src/components/AgencyDriverStats.js
// Displays driver statistics for the current agency by fetching counts from a single API endpoint
// (prevents double-fetching lane endpoints) and rendering them via StatusCounters.

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import StatusCounters from './StatusCounters';
import { selectLimitByAgency } from '../features/agencies/agenciesSlice';
import { selectAgencyIdForUser } from '../features/auth/authSlice';
import { selectStatsRefreshKey } from '../features/ui/filtersSlice';

import { fetchAgencyDriverStats } from '../services/driverService';

export default function AgencyDriverStats() {
  const agencyId = useSelector(selectAgencyIdForUser);
  const statsKey = useSelector(selectStatsRefreshKey);

  const rawCap = useSelector((state) =>
    agencyId != null ? selectLimitByAgency(state, agencyId) : null
  );
  const activeCap = Number.isFinite(Number(rawCap)) ? Number(rawCap) : null;

  const [counts, setCounts] = useState({
    Total: 0,
    Active: 0,
    Reserved: 0,
    Banned: 0,
  });

  useEffect(() => {

    // 🔎 DEBUG LOG (TEMP): effect trace
  console.log('[AgencyDriverStats] effect run', {
    agencyId,
    statsKey,
    at: Date.now(),
    path: window.location.pathname,
  });
    if (!agencyId) return;

    let cancelled = false;

    (async () => {
      try {
        const stats = await fetchAgencyDriverStats();
        if (cancelled) return;

        const Active = Number(stats?.active) || 0;
        const Reserved = Number(stats?.reserved) || 0;
        const Banned = Number(stats?.banned) || 0;
        const Total =
        Number.isFinite(Number(stats?.total_operational))
          ? Number(stats.total_operational)
          : (Active + Reserved + Banned);


        setCounts({ Total, Active, Reserved, Banned });
      } catch (e) {
        console.error('[AgencyDriverStats] failed to load stats', e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [agencyId, statsKey]);

  if (!agencyId) {
    return (
      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <p className="text-sm text-gray-600">Loading agency…</p>
      </div>
    );
  }

  return <StatusCounters title="Your Drivers" counts={counts} activeCap={activeCap} />;
}
